<script setup lang="ts">
import { Card } from '@/components/ui'
import { Settings } from 'lucide-vue-next'
</script>

<template>
  <div class="app-page app-page--narrow">
    <section class="app-page-header">
      <div class="app-page-heading">
        <div class="app-page-eyebrow">
          <Settings class="h-4 w-4" />
          <span>Preferences</span>
        </div>
        <h1 class="app-page-title">Connection preferences</h1>
        <p class="app-page-subtitle">Manage your accounting integration settings and preferences.</p>
      </div>
    </section>

    <Card>
      <div class="app-empty-state">
        <div class="app-empty-state-symbol">
          <Settings class="h-5 w-5" />
        </div>
        <div class="app-empty-state-title">Settings panel being prepared</div>
        <div class="app-empty-state-copy">
          Detailed integration preference controls will appear in a future update.
        </div>
      </div>
    </Card>
  </div>
</template>
